// Shared by AI preview and Apply to Editor, so the same draft keeps the same media.
export function processDraftItems(items: any[], existing: any[] = []): any[] {
    return (items || []).map(item => {
        const match = existing.find(old => old.header && old.header.trim() === String(item.header || '').trim());
        return {
            ...item,
            image: item.image || match?.image || '',
            image2: item.image2 || match?.image2 || undefined,
            video: item.video || match?.video || undefined,
            hideSectionLine: item.hideSectionLine ?? match?.hideSectionLine
        };
    });
}
